export default __webpack_public_path__ + "static/media/s1.c29cd97d.png";